
import React, { useEffect, useState } from 'react';
import { useAuth } from '../AuthProvider';
import { baseUrl_SPB } from '../BaseUrl';
import { TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, CircularProgress } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';

const InventorySearch = () => {
  const authContext = useAuth();
  const [inventory, setInventory] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchInventory = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${baseUrl_SPB}/api/v1/inventory/getinventories`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + authContext.token,
        },
      });
      if (!response.ok) throw new Error('Failed to fetch inventory');
      let data = await response.json();
      data = data.map(item => ({ ...item, key: item.id || uuidv4() }));
      setInventory(data);
      setFiltered(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if(authContext?.token)
      fetchInventory();
    // eslint-disable-next-line
  }, [authContext.token]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
    if (!value) {
      setFiltered(inventory);
      return;
    }
    const lower = value.toLowerCase();
    setFiltered(
      inventory.filter(item =>
        (item.itemName && item.itemName.toLowerCase().includes(lower)) ||
        (item.sku && item.sku.toLowerCase().includes(lower)) ||
        (item.barcode && item.barcode.toLowerCase().includes(lower)) ||
        (item.qrCode && item.qrCode.toLowerCase().includes(lower)) ||
        (item.binCode && item.binCode.toLowerCase().includes(lower)) ||
        (item.itemNumber && item.itemNumber.toLowerCase().includes(lower))
      )
    );
  };

  return (
    <Paper sx={{ padding: 2 }}>
      <Typography variant="h5" gutterBottom>Search Inventory</Typography>
      <TextField
        label="Search by name, SKU, code, bin..."
        value={search}
        onChange={handleSearch}
        fullWidth
        sx={{ mb: 2 }}
      />
      {loading ? <CircularProgress /> : error ? <Typography color="error">{error}</Typography> : (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>SKU</TableCell>
                <TableCell>Bin</TableCell>
                <TableCell>Barcode</TableCell>
                <TableCell>QR</TableCell>
                <TableCell>Quantity</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered.length === 0 ? (
                <TableRow><TableCell colSpan={6} align="center">No items found</TableCell></TableRow>
              ) : filtered.map(item => (
                <TableRow key={item.key}>
                  <TableCell>{item.itemName}</TableCell>
                  <TableCell>{item.sku}</TableCell>
                  <TableCell>{item.binCode}</TableCell>
                  <TableCell>{item.barcode}</TableCell>
                  <TableCell>{item.qrCode}</TableCell>
                  <TableCell>{item.quantity}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
};

export default InventorySearch;
